import { CSSProperties } from "react";
export const DCol = ({
  children,
  style,
  id,
  className,
}: {
  children?: any;
  style?: CSSProperties;
  id?: string;
  className?: string;
}) => {
  return (
    <div
      style={{ display: "flex", flex: 1, flexDirection: "column", ...style }}
      id={id}
      className={className}
    >
      {children || null}
    </div>
  );
};
